// Фасетний пошук — сортування

(function (Drupal, once) {
	Drupal.behaviors.bef_slider = {
		attach: function (context) {
			// once() на .views-sorts: після AJAX views контейнер пересоздається,
			// тому once() спрацює знову для нового елемента
			once('views-sorting', '.views-sorts', context).forEach(function () {
				const select = document.querySelector('[name="sort_bef_combine"]');
				if (!select) return;

				// Ховаємо дефолтну кнопку після AJAX-оновлення
				if (context !== document) {
					const sortDefault = document.querySelector('.sort-default');
					if (sortDefault) sortDefault.style.display = 'none';
				}

				attachSortHandlers();

				const currentSortValue = select.value;
				if (currentSortValue) {
					updateActiveClass(currentSortValue);
				}
			});

			function changeSorting(value) {
				const select = document.querySelector('[name="sort_bef_combine"]');
				const form = select.closest('form');
				const submit = form.querySelector('[data-bef-auto-submit-click]');

				select.value = value;

				// Тимчасово вимикаємо auto-submit
				const autoSubmitAttr = form.getAttribute('data-bef-auto-submit-full-form');
				form.removeAttribute('data-bef-auto-submit-full-form');

				submit.click();

				setTimeout(function () {
					if (autoSubmitAttr !== null) {
						form.setAttribute('data-bef-auto-submit-full-form', autoSubmitAttr);
					}
				}, 100);
			}

			function attachSortHandlers() {
				const handlers = {
					'.sort-alephbeit_az': 'title_ASC',
					'.sort-alephbeit_za': 'title_DESC',
					'.sort-cheaper': 'number_1_ASC',
					'.sort-expensive': 'number_1_DESC',
				};

				Object.entries(handlers).forEach(function ([selector, value]) {
					const el = document.querySelector(selector);
					if (el) {
						el.onclick = function () {
							changeSorting(value);
						};
					}
				});
			}

			function updateActiveClass(sortValue) {
				document.querySelectorAll('.sort-handler').forEach(function (el) {
					el.classList.remove('active');
				});

				const sortMap = {
					field_lbl_new_DESC: '.sort-new',
					field_queue_ASC: '.sort-rating',
					title_ASC: '.sort-alephbeit_az',
					title_DESC: '.sort-alephbeit_za',
					number_1_ASC: '.sort-cheaper',
					number_1_DESC: '.sort-expensive',
				};

				const selector = sortMap[sortValue];
				if (selector) {
					const el = document.querySelector(selector);
					if (el) el.classList.add('active');
				}
			}
		},
	};
})(Drupal, once);
